import { classNames } from '@panwds/tailwindcss';
import React from 'react';
import { getDataTestId } from '../../../utils/utils.js';
import { List } from '../../List/List.js';
import { ListItem } from '../../List/ListItem.js';
export const LayoutList = (props) => {
    const { className, items, selectedItem, onSelectOption } = props;
    const style = {
        maxHeight: '100%',
        minWidth: '7.5rem',
        maxWidth: '7.5rem'
    };
    const rootClassName = typeof className === 'string' ? className : className?.root;
    const dataTestId = getDataTestId('item', props.dataTestId);
    return (React.createElement(List, { dataTestId: getDataTestId('item_container', dataTestId), ...(selectedItem?.value === 'custom'
            ? {
                style: { ...style, borderRadius: 0, boxShadow: 'none' },
                addClassName: classNames('twds-border-0 dark:twds-border-0', 'twds-border-r dark:twds-border-r twds-border-gray-300 dark:twds-border-gray-900', 'twds-bg-white dark:twds-bg-gray-950', rootClassName)
            }
            : {
                style,
                addClassName: classNames('twds-bg-white dark:twds-bg-gray-950', rootClassName)
            }) }, items.map((obj) => {
        return (React.createElement(ListItem, { dataTestId: getDataTestId(`item_${obj.value}`, dataTestId), key: obj.value, value: obj.value, active: obj.value === selectedItem?.value, addClassName: classNames(obj.value === selectedItem?.value ? 'dark:twds-bg-gray-800' : 'dark:twds-bg-transparent', typeof className === 'object' ? className?.listItemClassName : undefined), onClick: () => !obj.disabled && onSelectOption(obj), disabled: obj.disabled }, obj.children || obj.value));
    })));
};
//# sourceMappingURL=layout_list.js.map